(function () {
  'use strict';

  var lastImpactValue = 0;
  // Spendenlogik basiert immer auf Euro (1 € = 1 m²)
  var IMPACT_BASE_CURRENCY = 'EUR';

  function getImpactElement() {
    return document.querySelector('.mini-cart__impact-number[data-impact-target]');
  }

  function getTargetValue(el) {
    if (!el) return null;
    var raw = el.dataset.impactTarget || el.textContent || '';
    var numeric = parseInt(String(raw).replace(/[^\d]/g, ''), 10);
    if (isNaN(numeric)) return null;

    // Wenn der Shop mit Fremdwährungen arbeitet, wird der Cart-Total in der aktiven
    // Kundenwährung geführt. Unsere Spendenaktion rechnet aber immer in Euro.
    // Annahme:
    //   - Shopify.currency.active: aktuelle Kundenwährung (z.B. 'CZK')
    //   - Shopify.currency.rate: Faktor, mit dem aus Shop-Währung -> Kundenwährung
    //     umgerechnet wird (z.B. 25 für EUR -> CZK).
    //   - Shop-Währung ist EUR.
    //
    // Dann gilt: betrag_aktiv = betrag_eur * rate  =>  betrag_eur = betrag_aktiv / rate
    try {
      if (typeof window !== 'undefined' && window.Shopify && Shopify.currency) {
        var activeCurrency = (Shopify.currency.active || '').toUpperCase();
        var rate = parseFloat(Shopify.currency.rate || '1');

        if (
          activeCurrency &&
          IMPACT_BASE_CURRENCY &&
          activeCurrency !== IMPACT_BASE_CURRENCY &&
          rate &&
          rate > 0
        ) {
          numeric = Math.round(numeric / rate);
        }
      }
    } catch (e) {
      // Fallback: lieber ungeänderten Wert anzeigen, als den Counter ganz zu brechen
    }

    return numeric;
  }

  function animateTo(target) {
    var el = getImpactElement();
    if (!el) return;

    // Reduced Motion: direkt setzen, ohne Animation
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = String(target);
      lastImpactValue = target;
      return;
    }

    var start = lastImpactValue || 0;
    var end = target;
    var duration = 600;
    var startTime = performance.now();

    el.classList.add('is-animating');

    function step(now) {
      var elapsed = now - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 2); // easeOutQuad
      var value = Math.round(start + (end - start) * eased);
      el.textContent = String(value);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.classList.remove('is-animating');
        lastImpactValue = end;
      }
    }

    requestAnimationFrame(step);
  }

  function updateImpact() {
    try {
      var el = getImpactElement();
      if (!el) return;
      var target = getTargetValue(el);
      if (target === null) return;
      animateTo(target);
    } catch (e) {
      console.error(e);
    }
  }

  function scheduleUpdate() {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        requestAnimationFrame(updateImpact);
      });
    } else {
      setTimeout(updateImpact, 60);
    }
  }

  // Initial, falls Drawer bereits offen ist
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    scheduleUpdate();
  } else {
    document.addEventListener('DOMContentLoaded', scheduleUpdate);
  }

  // Events, die den Mini-Cart neu rendern
  ['cartdrawer:opened', 'ajaxProduct:added', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, scheduleUpdate);
  });
})();



